<template>
  <Modal v-model="createFileModal" :mask-closable="false" width="600">
    <p slot="header" class="text-center">
        <span>创建数据文件</span>
    </p>

    <Form
      ref="fileData"
      :model="fileData"
      label-position="top"
    > <FormItem label="选择导出文件类型">
        <RadioGroup v-model="fileData.fileType">
          <Radio
            v-for="fileTypeItem in fileTypeArray"
            :key="fileTypeItem.value"
            :label="fileTypeItem.value"
          >
            {{ fileTypeItem.label }}
          </Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="选择项目">
        <RadioGroup v-model="fileData.projectId">
           <Radio
            :key="-1"
            :label="-1"
          >
            全部项目
          </Radio>
          <Radio
            v-for="projectItem in projectArray"
            :key="projectItem.id"
            :label="projectItem.id"
          >
            {{ projectItem.name }}
          </Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="选择数据类型">
        <RadioGroup v-model="fileData.dataType">
          <Radio
            v-for="dataTypeItem in dataTypeArray"
            :key="dataTypeItem.value"
            :label="dataTypeItem.value"
          >
            {{ dataTypeItem.label }}
          </Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="数据范围">
        <div class="date-range-container">
          <div class="date-range-item">
            <span class="date-label">从</span>
            <DatePicker
              v-model="fileData.startDate"
              type="month"
              placeholder="选择开始年月"
              style="width: 180px"
              size="small"
              :clearable="false"
              @on-change="handleStartDateChange"
            ></DatePicker>
          </div>
          <div class="date-range-item">
            <span class="date-label">到</span>
            <DatePicker
              v-model="fileData.endDate"
              type="month"
              placeholder="选择结束年月"
              style="width: 180px"
              size="small"
              :clearable="false"
              @on-change="handleEndDateChange"
            ></DatePicker>
          </div>
        </div>
      </FormItem>
    </Form>

    <div slot="footer">
      <Button class="ivu-btn ivu-btn-text ivu-btn-large" @click="createFileModal=false">
        <span>取消</span>
      </Button>
      <Button class="ivu-btn ivu-btn-primary ivu-btn-large" :loading="loading" @click="handleCreate">
        <span>确定</span>
      </Button>
    </div>
  </Modal>
</template>

<script>
import { getList as getProjectList } from '@/api/os/project'
import { getExprotDataTypes, createExport } from '@/api/dw/platform'

export default {
  data () {
    return ({
      createFileModal: false,
      loading: false,

      fileData: {
        projectId: -1,
        dataType: 1,
        fileType: 1, // 默认选择excel文件
        startDate: null,
        endDate: null
      },

      projectArray: [],
      dataTypeArray: [],

      fileTypeArray: [
        { value: 1, label: 'excel文件' },
        { value: 2, label: '附件文件' }
      ]
    })
  },

  created () {
    this.initData()
  },
  methods: {
    showModal () {
      this.createFileModal = true
    },

    async initData () {
      try {
        // 获取项目列表
        const projectParams = {
          publisherId: this.$store.getters.token.userInfo.publisherId
        }
        const projectResponse = await getProjectList(projectParams)
        if (projectResponse && projectResponse.length > 0) {
          this.projectArray = projectResponse
        }

        // 获取数据类型列表 - getExprotDataTypes 方法定义接受 data 参数，但可以为空对象或不传
        const dataTypeResponse = await getExprotDataTypes({})
        if (dataTypeResponse.data && dataTypeResponse.data.length > 0) {
          this.dataTypeArray = dataTypeResponse.data
        }
      } catch (error) {
        this.$Notice.error({
          title: '初始化失败',
          desc: '获取数据失败：' + (error.message || '未知错误')
        })
      }
    },

    resetForm () {
      this.fileData.projectId = -1
      this.fileData.dataType = 1
      this.fileData.fileType = 1
      this.fileData.startDate = null
      this.fileData.endDate = null
    },

    handleStartDateChange (date) {
      this.fileData.startDate = date
    },

    handleEndDateChange (date) {
      this.fileData.endDate = date
    },

    async handleCreate () {
      // 验证表单
      if (!this.fileData.projectId) {
        this.$Notice.warning({
          title: '验证失败',
          desc: '请选择项目'
        })
        return
      }

      if (!this.fileData.dataType) {
        this.$Notice.warning({
          title: '验证失败',
          desc: '请选择数据类型'
        })
        return
      }

      if (!this.fileData.startDate || !this.fileData.endDate) {
        this.$Notice.warning({
          title: '验证失败',
          desc: '请选择数据范围'
        })
        return
      }

      this.loading = true

      try {
        // 获取项目名称
        let projectName = '全部项目'
        if (this.fileData.projectId !== -1) {
          const selectedProject = this.projectArray.find(item => item.id === this.fileData.projectId)
          if (selectedProject) {
            projectName = selectedProject.name
          }
        }

        // 调用API创建导出记录
        const createParams = {
          projectId: this.fileData.projectId,
          projectName: projectName,
          opType: this.fileData.dataType,
          fileType: this.fileData.fileType,
          startDate: this.fileData.startDate,
          endDate: this.fileData.endDate
        }

        await createExport(createParams)

        this.$Notice.success({
          title: '创建成功',
          desc: '已成功创建导出记录'
        })

        // 清空表单，关闭弹窗
        this.createFileModal = false
        this.resetForm()

        // 刷新列表数据
        this.$store.commit('set_dataUpload_update', new Date())
      } catch (error) {
        this.$Notice.error({
          title: '创建失败',
          desc: '创建导出记录失败：' + (error.message || '未知错误')
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.ivu-form-item {
  margin-bottom: 20px;
}

/* 日期选择器样式优化 */
.date-range-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.date-range-item {
  flex: 1;
  display: flex;
  align-items: center;
}

.date-range-item:first-child {
  margin-right: 10px;
}

.date-label {
  color: #666;
  margin-right: 8px;
  min-width: 30px;
  text-align: right;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .ivu-modal {
    width: 90% !important;
  }

  .date-range-container {
    flex-direction: column;
  }

  .date-range-item:first-child {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>
